import blockInactivePdvAccess from '@/router/guards/pdv-inactive'

const basePath = '/pdv/atm'

export default [
  // Rota raiz do ATM - redireciona para identificação do cliente
  {
    path: `${basePath}`,
    redirect: `${basePath}/identify-customer`,
  },
  // Tela inicial para identificar o cliente
  {
    path: `${basePath}/identify-customer`,
    name: 'pdv-atm-identify-customer',
    component: () => import('@/views/pages/pdv/atm/AtmIdentifyCustomer.vue'),
    beforeEnter: blockInactivePdvAccess,
    props: { isAtm: true },
    meta: {
      layout: 'full',
      pageTitle: 'Identificar Cliente',
      resource: 'Auth',
      action: 'read',
    },
  },
  // Catalog
  {
    path: `${basePath}/home`,
    name: 'pdv-atm',
    component: () => import('@/views/pages/pdv/atm/Atm.vue'),
    beforeEnter: blockInactivePdvAccess,
    props: { isAtm: true },
    meta: {
      layout: 'atm',
      pageTitle: 'Catálogo',
      resource: 'Auth',
      action: 'read',
    },
  },
  // lock-screen - redireciona para identificação do cliente
  {
    path: `${basePath}/lock-screen`,
    name: 'pdv-atm-lock-screen',
    redirect: `${basePath}/identify-customer`,
  },
  {
    path: `${basePath}/configuration`,
    name: 'pdv-atm-configuration',
    component: () => import('@/views/pages/pdv/pay-box-configuration/PayBoxConfiguration.vue'),
    meta: {
      pageTitle: 'Configuração do ATM',
      layout: 'atm',
      resource: 'PayBox',
      action: 'Setup',
    },
  },
]
